import { createRoute } from '@tanstack/react-router';
import { CarrierRulePage } from '@/features/carriers/carrier-rule-page.js';
import { authenticatedRoute } from './authenticated.js';
export const transporteurNewRoute = createRoute({ getParentRoute: () => authenticatedRoute, path: '/transporteurs/nouvelle', component: () => <CarrierRulePage isNew /> });
